<template>
  <div class="detail" v-if="showDeviceDetail">
    <div class="closeDetail" @click.prevent.stop="closeDetail">
      <i class="iconfont iconright"></i>
    </div>
    <header>
      <div class="title">
        {{ deviceList.deviceName }}
        <span :class="deviceList.status !== 1 ? 'iActive' : ''">
          <i></i>{{ deviceList.deviceStatusName }}
        </span>
      </div>
      <div class="detailContent">
        <div class="deviceIcon">
          <span
            ><i :class="'iconfont ' + (deviceList.icon || 'iconweidingyi-')"></i
          ></span>
        </div>
        <div>
          <p>设备编码：{{ deviceList.device_mark || deviceList.deviceId }}</p>
          <p>设备区域：{{ deviceList.region || deviceList.address }}</p>
        </div>
      </div>
    </header>
    <div class="switchInfo" v-if="allDataList.length > 0">
      <div class="switchInfo-top">
        <div
          class="switchInfo-item"
          v-for="(item, index) in dataList"
          :key="index"
          :class="{ 'switchInfo-selected': currentData == item.name }"
          @click="changeTab(index, item.name)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="itemCons">
        <ul class="itemCon" id="itemCon">
          <li
            class="data-item"
            v-for="(item, index) in itemList"
            :key="index"
            :class="{ 'data-selected': item.dataflowFlag == currentItem }"
            @click="changeItem(item)"
          >
            <div class="items">
              <div class="circle">
                {{
                  item.dataflowName.includes('状态')
                    ? '状态'
                    : item.dataflowSymbol
                }}
              </div>
              <div class="name">{{ item.dataflowName }}</div>
            </div>
            <div class="value">{{ item.dataflowData }}</div>
          </li>
        </ul>
        <i
          class="iconfont iconleft"
          id="left"
          @click="left()"
          v-if="itemList.length > 5"
        ></i>
        <i
          class="iconfont iconright"
          id="right"
          @click="right()"
          v-if="itemList.length > 5"
        ></i>
      </div>
    </div>
    <div class="information">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="设备信息" name="first">
          <div v-if="!currentName.includes('状态')">
            <div class="statusName">{{ currentName }}</div>
            <div class="lineChart">
              <simpleChart :chartDatas="chartDatas"></simpleChart>
            </div>
          </div>
          <div v-if="currentName.includes('状态')">
            <div class="statusName">{{ currentName }}</div>
            <div class="statusPic">
              <div class="leftBar">
                <div
                  class="barItem"
                  :class="{ 'barItem-selected': currentFlowData == '分闸' }"
                ></div>
                <div
                  class="barItem"
                  :class="{ 'barItem-selected': currentFlowData == '合闸' }"
                ></div>
                <div class="line"></div>
              </div>
              <div class="rightCon">
                {{ currentFlowData }}
              </div>
            </div>
            <div class="tips">*合闸分闸请输入密码</div>
            <div class="captchContent">
              <el-input
                v-for="(item, index) in captchas"
                :key="index"
                v-model="item.num"
                :id="'captcha' + index"
                @focus="adjust"
                class="auth-b"
                type="password"
                maxlength="1"
              />
            </div>
            <div class="btnCon">
              <el-button
                class="btns"
                @click="operationData"
                :loading="btnLoading"
              >
                {{ currentFlowData == '分闸' ? '合闸' : '分闸' }}
              </el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="报警信息" name="second">
          <div class="searchTime">
            <el-date-picker
              v-model="startTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="请选择开始时间"
            />
            <el-date-picker
              v-model="endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择结束时间"
            />
            <div class="searchSubmit" @click.prevent.stop="_searchSubmit">
              <i style="color: #2f82b7" class="el-icon-search"></i>
            </div>
          </div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="startTime" label="报警时间" width="180">
            </el-table-column>
            <el-table-column prop="alarmDesc" label="报警内容">
            </el-table-column>
            <el-table-column label="操作" width="100" align="left">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.alarmStatus !== 4"
                  type="warning"
                  size="small"
                  >未处理</el-tag
                >
                <el-tag v-else type="success" size="small">已处理</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import simpleChart from './simpleChart'
  export default {
    components: {
      simpleChart
    },
    props: {
      deviceList: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        showDeviceDetail: false,
        activeName: 'first',
        // 报警查询开始时间
        startTime: '',
        // 报警查询结束时间
        endTime: '',
        // 报警信息列表
        tableData: [],
        isDataFlow: false,
        chartDatas: {},
        dataList: [
          {
            name: '主路'
          },
          {
            name: 'A相'
          },
          {
            name: 'B相'
          },
          {
            name: 'C相'
          }
        ],
        currentData: '主路',
        currentItem: '',
        currentName: '', // 当前数据名称
        currentFlowData: '',
        currentIndex: 0,
        allDataList: [],
        transIndex: [0, 0, 0, 0],
        captchas: [
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          }
        ],
        zipCode: [
          'captcha0',
          'captcha1',
          'captcha2',
          'captcha3',
          'captcha4',
          'captcha5'
        ],
        deviceId: '',
        deviceTypeId: '',
        timer: '',
        btnLoading: false
      }
    },
    computed: {
      itemList() {
        return this.allDataList
          .filter(i => {
            return i.dataflowName.includes(this.currentData)
          })
          .reverse()
      }
    },
    methods: {
      checkDetail(e) {
        let { deviceId, id, deviceType } = e
        this.deviceId = deviceId
        this.deviceTypeId = deviceType
        this._deviceAlarm({ deviceId: deviceId })
        this.$axiosget(
          `taos/taosdata/query_latest?id=${id}&typeId=${deviceType}`
        ).then(res => {
          this.allDataList = res.data.data || []
          this.currentItem =
            this.itemList.length > 0 ? this.itemList[0].dataflowFlag : ''
          this.currentName =
            this.itemList.length > 0 ? this.itemList[0].dataflowName : ''
          this.currentFlowData =
            this.itemList.length > 0 ? this.itemList[0].dataflowData : ''
          if (!this.currentName.includes('状态')) {
            clearInterval(this.timer)
            this.getActualData()
            this.timer = setInterval(() => {
              this.getActualData()
            }, 10000)
          }
          this.showDeviceDetail = true
        })
      },
      changeTab(i, val) {
        this.currentIndex = i
        this.currentData = val
        this.currentItem =
          this.itemList.length > 0 ? this.itemList[0].dataflowFlag : ''
        this.currentName =
          this.itemList.length > 0 ? this.itemList[0].dataflowName : ''
        this.currentFlowData =
          this.itemList.length > 0 ? this.itemList[0].dataflowData : ''
        this.captchas = [
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          }
        ]
        if (this.activeName == 'first' && !this.currentName.includes('状态')) {
          clearInterval(this.timer)
          this.getActualData()
          this.timer = setInterval(() => {
            this.getActualData()
          }, 10000)
        }
      },
      handleClick() {
        if (this.activeName == 'first' && !this.currentName.includes('状态')) {
          clearInterval(this.timer)
          this.getActualData()
          this.timer = setInterval(() => {
            this.getActualData()
          }, 10000)
        }
      },
      changeItem(item) {
        this.currentItem = item.dataflowFlag
        this.currentName = item.dataflowName
        this.currentFlowData = item.dataflowData
        this.captchas = [
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          },
          {
            num: ''
          }
        ]
        if (this.activeName == 'first' && !this.currentName.includes('状态')) {
          clearInterval(this.timer)
          this.getActualData()
          this.timer = setInterval(() => {
            this.getActualData()
          }, 10000)
        }
      },
      left() {
        if (this.transIndex[this.currentIndex] == 0) {
          return
        }
        this.transIndex[this.currentIndex]--
        let vdom = document.querySelectorAll('#itemCon')[0]
        vdom.style.transform =
          'translateX(' + -92 * this.transIndex[this.currentIndex] + 'px' + ')'
      },
      right() {
        let index = this.itemList.length - 5
        this.transIndex[this.currentIndex]++
        if (this.transIndex[this.currentIndex] > index) {
          this.transIndex[this.currentIndex]--
          return
        }
        let vdom = document.querySelectorAll('#itemCon')[0]
        vdom.style.transform =
          'translateX(' + -92 * this.transIndex[this.currentIndex] + 'px' + ')'
      },
      adjust(event) {
        let _this = this
        let nextZip = ''
        let dom = document.getElementById(event.target.id)
        if (dom) {
          dom.addEventListener('keyup', function() {
            if (event.target.value.length === event.target.maxLength) {
              _this.zipCode.filter((x, index) => {
                if (x === event.target.id) {
                  index === _this.zipCode.length - 1
                    ? (nextZip = _this.zipCode[index])
                    : (nextZip = _this.zipCode[index + 1])
                }
              })
              let nextDom = document.getElementById(nextZip)
              if (nextDom) nextDom.focus()
            } else if (event.target.value.length === 0) {
              _this.zipCode.filter((x, index) => {
                if (x === event.target.id) {
                  index === 0
                    ? (nextZip = _this.zipCode[index])
                    : (nextZip = _this.zipCode[index - 1])
                }
              })
              let nextDom = document.getElementById(nextZip)
              if (nextDom) nextDom.focus()
            }
          })
        }
      },
      operationData() {
        let pwd = this.captchas.map(a => a.num).join('')
        if (pwd == '') {
          this.$message.error('请输入密码')
          return
        } else if (process.env.passWord != pwd) {
          this.$message.error('密码输入错误,请重新输入')
          return
        } else {
          this.btnLoading = true
          this.$axiospost('operation/command/add', {
            deviceId: this.deviceId,
            deviceType: this.deviceTypeId,
            serviceName: this.currentFlowData == '分闸' ? 'A1' : 'A2',
            serviceType: 'D3',
            type: 0,
            domains: [
              {
                value: '1',
                valueName: this.currentFlowData == '分闸' ? 'A1' : 'A2'
              }
            ]
          }).then(res => {
            if (res.data.status == 10000) {
              this.captchas = [
                {
                  num: ''
                },
                {
                  num: ''
                },
                {
                  num: ''
                },
                {
                  num: ''
                },
                {
                  num: ''
                },
                {
                  num: ''
                }
              ]
              this.btnLoading = false
              this.$axiosget(
                `taos/taosdata/query_latest?id=${this.deviceId}&typeId=${this.deviceTypeId}`
              ).then(res => {
                this.allDataList = res.data.data || []
                this.currentItem =
                  this.itemList.length > 0 ? this.itemList[0].dataflowFlag : ''
                this.currentName =
                  this.itemList.length > 0 ? this.itemList[0].dataflowName : ''
                this.currentFlowData =
                  this.itemList.length > 0 ? this.itemList[0].dataflowData : ''
                if (
                  this.activeName == 'first' &&
                  !this.currentName.includes('状态')
                ) {
                  clearInterval(this.timer)
                  this.getActualData()
                  this.timer = setInterval(() => {
                    this.getActualData()
                  }, 10000)
                }
              })
            }
          })
        }
      },
      getActualData() {
        this.$axiosget('taos/taosdata/query_simple', {
          params: {
            id: this.deviceId,
            dataflowFlag: this.currentItem,
            pageNum: 1,
            pageSize: 10
          }
        }).then(res => {
          let allData = res.data.data.data.reverse()
          let areaChartData = {
            categories: [],
            seriesData: []
          }
          areaChartData.categories = allData.map(item =>
            item.createTime.slice(0, item.createTime.indexOf('.'))
          )
          areaChartData.seriesData = allData.map(item => item.dataflowData)
          this.chartDatas = areaChartData
        })
      },
      // 关闭设备详情
      closeDetail() {
        this.showDeviceDetail = false
        clearInterval(this.timer)
      },
      // 报警信息搜索
      _searchSubmit() {
        let data = {
          startTime: this.startTime,
          endTime: this.endTime ? this.endTime + ' 23:59:59' : '',
          deviceId: this.deviceList.device_mark
        }
        this._deviceAlarm(data)
      },
      // 报警信息查询
      _deviceAlarm(params) {
        this.$axiospost(
          'operation/deviceAlarmApi/getAlarmNowPageList',
          params
        ).then(res => {
          this.tableData = res.data.data.list || []
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .detail {
    width: 510px;
    padding: 25px;
    position: absolute;
    z-index: 633;
    top: 50px;
    right: 20px;
    background: #0d1424d3;
    overflow: hidden;
    .detailContent {
      padding: 10px;
      display: flex;
      align-items: center;
      .deviceIcon {
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        background: url('../imgaes/electric.png') no-repeat;
        background-size: contain;
        i {
          color: #00b9ff;
        }
      }
    }
    .closeDetail {
      position: absolute;
      left: 5px;
      top: 50%;
      z-index: 345;
      color: #36bfffb8;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    .switchInfo {
      .switchInfo-top {
        display: flex;
        align-items: center;
        border: 1px solid rgb(21, 74, 104);
      }
      .switchInfo-item {
        cursor: pointer;
        padding: 10px 15px;
        font-size: 14px;
        color: #fff;
        border-right: 1px solid rgb(21, 74, 104);
      }

      .switchInfo-selected {
        background: rgb(48, 90, 121);
        color: #35b9f7;
      }

      .itemCons {
        width: 100%;
        height: 131px;
        border-right: 1px solid rgb(21, 74, 104);
        border-bottom: 1px solid rgb(21, 74, 104);
        border-left: 1px solid rgb(21, 74, 104);
        overflow: auto;
        white-space: nowrap;
        position: relative;

        #left,
        #right {
          position: absolute;
          top: 41%;
          display: block;
          width: 15px;
          height: 40px;
          line-height: 40px;
          z-index: 10;
          color: #ffffff;
          font-size: 12px;
          background: #212740;
          opacity: 0.8;
          cursor: pointer;
        }

        #left {
          left: 0;
        }

        #right {
          right: 0;
        }
      }

      .itemCon {
        display: inline-block;
        white-space: nowrap;
        transition: 0.5s;

        .data-item {
          cursor: pointer;
          width: 92px;
          height: 130px;
          border-right: 1px solid rgb(21, 74, 104);
          display: inline-block;

          .items {
            height: 100px;
            border-bottom: 1px solid rgb(21, 74, 104);
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 5px 0;

            .circle {
              display: inline-block;
              background: url('../imgaes/electric.png') no-repeat;
              background-size: contain;
              width: 60px;
              height: 60px;
              border-radius: 100%;
              text-align: center;
              line-height: 60px;
              font-size: 14px;
              color: #fff;
            }

            .name {
              margin-top: 5px;
              font-size: 14px;
              color: #fff;
            }
          }

          .value {
            height: 30px;
            text-align: center;
            font-size: 14px;
            line-height: 30px;
            color: #fff;
          }
        }

        .data-selected {
          background: #115394c9;
        }
      }
      ::-webkit-scrollbar {
        overflow: scroll;
        width: 0px;
        height: 0;
      }
    }
    header {
      .title {
        width: 100%;
        height: 40px;
        background: url('../imgaes/detailHeaderBg.png') no-repeat;
        color: #ccc;
        font-size: 16px;
        padding-left: 15px;
        padding-top: 5px;
        span {
          color: #01ef99;
          float: right;
          i {
            margin-right: 5px;
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 5px;
            background-color: #01ef99;
          }
        }
        .iActive {
          color: #ef0101;
          i {
            background-color: #ef0101;
          }
        }
      }
      p {
        padding-left: 20px;
        color: #cacaca;
        font-size: 14px;
        line-height: 40px;
      }
    }

    .information {
      .searchTime {
        height: 60px;
        margin: 15px 0;
        padding: 10px;
        background: #1926435e;
        .searchSubmit {
          display: inline-block;
          width: 40px;
          height: 40px;
          border-radius: 50px;
          background-color: #283b65;
          text-align: center;
          line-height: 40px;
        }
      }
    }
    /deep/ .el-input__prefix {
      line-height: 40px;
    }
    /deep/ .el-table {
      height: 400px;
      background: #0d14240a;
    }
    /deep/ .el-table__body-wrapper {
      max-height: 340px;
      overflow: scroll;
      background-color: #0d142410;
    }
    .el-tag.el-tag--warning {
      color: #f67516;
      border: 1px solid #f67516;
      background: #3d2522;
    }
    .el-tag.el-tag--success {
      background: #0b0e1d;
      border: 1px solid #314081;
      color: #314081;
    }
    /deep/.el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 188px;
      color: #00b8f7;
    }
    /deep/ .el-input__inner {
      background-color: #141f3618;
      border-color: #253658;
    }
    /deep/ .el-tabs__nav-wrap::after {
      background-color: #161f32;
    }
    /deep/ .el-tabs__item {
      color: #ccc;
    }
    /deep/ .el-tabs__header {
      color: #218dd1;
    }
    /deep/ .el-tabs__item.is-active {
      border-bottom: #35b9f7;
    }
    /deep/ .el-table th {
      background: #1926431c;
      color: #35b9f7;
    }
    /deep/ .el-table tr {
      background: #0d15252a;
      color: #98a6c5;
    }
    /deep/.el-table td {
      border-bottom: 1px dashed #ccc;
    }

    .lineChart {
      width: 100%;
      height: 300px;
    }

    .statusName {
      text-align: center;
      margin: 10px auto;
      font-size: 14px;
      color: #fff;
    }

    .statusPic {
      margin: 30px auto 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      .leftBar {
        width: 150px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #7d7d7d;
        position: relative;
        .barItem {
          flex: 1;
          height: 100%;
        }

        .line {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 10px;
          height: 88px;
          background: #306ac9;
        }

        .barItem-selected {
          background: #115394c9;
        }
      }

      .rightCon {
        margin-left: 100px;
        font-size: 18px;
        color: #fff;
      }
    }

    .tips {
      text-align: center;
      font-size: 14px;
      color: #fff;
      margin: 40px 0 20px;
    }

    .captchContent {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .auth-b {
        width: 50px !important;
        height: 50px;
        outline: none;
        font-size: 30px;
        line-height: 50px;
        text-align: center;
        border: 1px solid #35b9f7;

        /deep/.el-input__inner {
          text-align: center;
          height: 100%;
          line-height: 50px;
          color: #01ef99;
        }
      }
    }

    .btnCon {
      margin: 20px auto;
      text-align: center;
    }

    .btns {
      text-align: center;
      width: 100px;
      height: 40px;
      background: #306ac9;
      cursor: pointer;
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      text-align: center;
      border: 0;
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/lv2/appMonitor/switchDetail/index.vue